/**
 * Thulir — Image save deterrent.
 *
 * Blocks the casual save gestures on images: right-click "Save image as…",
 * drag-to-desktop, and the mobile long-press menu (paired with the CSS in
 * thulir-utilities.css). It only cancels `contextmenu` and `dragstart`, so
 * left-click / tap interactions (lightbox zoom, gallery nav, links) are
 * untouched.
 *
 * Note: this is a deterrent, not a lock — the image still loads from the public
 * CDN, so screenshots and devtools can always reach it. By design.
 */
(function () {
  'use strict';

  function overImage(target) {
    return target && target.closest && target.closest('img, picture');
  }

  document.addEventListener('contextmenu', function (e) {
    if (overImage(e.target)) e.preventDefault();
  });

  document.addEventListener('dragstart', function (e) {
    if (overImage(e.target)) e.preventDefault();
  });
})();
